module.exports = __webpack_public_path__ + "static/media/converge.5573ff2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/converge.jpg
// module id = 545
// module chunks = 0